import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "../css/others/Table.css";
import Pagination from "../Reusablecomponents/Pagination";
import ExportButton from "../Reusablecomponents/ExportButton";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import ToastPopup from "../popups/ToastPopup";
import { buildUserPayload } from "../main/buildUserPayload";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { ICampaign, IStatusEnum, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import { HiArrowPath } from "react-icons/hi2";
import EncryptionUtils from "../main/encryptionUtils";
const CampaignDetailsProjects: React.FC = () => {
  const { campaignId } = useParams<{ campaignId: string }>();
  const [filteredCampaigns, setFilteredCampaigns] = useState<ICampaign[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<Set<string>>(new Set());
  const [selectedEmails, setSelectedEmails] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const campaignName = location.state?.campaignName;
  const campaignStatus = location.state?.campaignStatus;
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const [showOverridePopup, setShowOverridePopup] = useState(false);
  const [remark, setRemark] = useState("");
  const [statusEnums, setStatusEnums] = useState<IStatusEnum[]>([]);
  const [auditStatusEnums, setAuditStatusEnums] = useState<IStatusEnum[]>([]);
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'ascending' | 'descending' } | null>(null);
  const [adminReviewCount, setAdminReviewCount] = useState<number>(0);
  const [actionType, setActionType] = useState<'EXCLUDE' | 'INCLUDE' | 'OVERRIDE' | null>(null);
  const [fields, setFields] = useState<any>({});
  const [, setUserRole] = useState<string>("");
  const clientId = localStorage.getItem("clientId");
  const providerId = localStorage.getItem("providerId");
  const loggedInEmail = localStorage.getItem("email");
  const updatedBy = localStorage.getItem("email");
  const { roleName } = EncryptionUtils.getAuthInfo();
  const [overrideProgress, setOverrideProgress] = useState<{ total: number; processed: number; status: string; successCount: number; failedCount: number; failedProjects: string[]; estimatedTimeRemaining: string; } | null>(null);
  const [isProcessingOverride, setIsProcessingOverride] = useState(false);
  const pollingIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const pollingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const abortControllerRef = useRef<AbortController | null>(null);
  const [campaignQcReviewDuration, setCampaignQcReviewDuration] = useState<number>(0);
  const [campaignStartDate, setCampaignStartDate] = useState<string | null>(null);
  const startTimeRef = useRef<number>(0);
  const processedCountRef = useRef<number>(0);
  const restrictedChars = /[\\:*?"<>|/]/;
  const qcBufferDate = localStorage.getItem("qcBufferDate");
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs["campaigns"]) {
      setFields(permissions.tabs["campaigns"].fields);
    } else {
      console.log("No permissions found for 'campaigns' tab");
    }
    setUserRole(roleName);
  }, [roleName]);
  useEffect(() => {
    const fetchClientConfig = async () => {
      try {
        const response = await apiCall("get", `/api/client-config/${clientId}`);
        setCampaignQcReviewDuration(response?.campaignQcReviewDuration || 0);
      } catch (error) {
        console.error("Error fetching client config:", error);
      }
    };
    if (clientId) {
      fetchClientConfig();
    }
  }, [clientId]);
  useEffect(() => {
    if (location.state?.campaignStartDate) {
      setCampaignStartDate(location.state.campaignStartDate);
    }
  }, [location.state]);
  const canShowProjectActionButtons = () => {
    if (!campaignStartDate || !campaignQcReviewDuration) return false;
    const startDate = new Date(campaignStartDate);
    const visibleFromDate = new Date(startDate);
    visibleFromDate.setDate(startDate.getDate() - campaignQcReviewDuration);
    const currentDate = new Date();
    startDate.setHours(0, 0, 0, 0);
    visibleFromDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
    return currentDate >= visibleFromDate && currentDate <= startDate;
  };
  const cleanupPolling = useCallback(() => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
    if (pollingTimeoutRef.current) {
      clearTimeout(pollingTimeoutRef.current);
      pollingTimeoutRef.current = null;
    }
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
    startTimeRef.current = 0;
    processedCountRef.current = 0;
  }, []);
  useEffect(() => {
    return cleanupPolling;
  }, [cleanupPolling]);
  const requestSort = (key: string) => {
    let direction: 'ascending' | 'descending' = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
  const getSortedItems = () => {
    if (!sortConfig) return filteredCampaigns;
    return [...filteredCampaigns].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  };
  const sortedCampaigns = getSortedItems();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const payload = buildUserPayload();
      let requestBody = [{ field: "campaignId", operator: "=", value: campaignId }, { field: "isAvailable", operator: "=", value: false }, { field: "clientId", operator: "=", value: clientId }, ...(payload ? [payload] : [])];
      if (location.state?.filterData) { requestBody = [...requestBody, ...location.state.filterData]; }
      try {
        const response = await apiCall("post", `/api/campaign-projects/search?page=${currentPage - 1}&size=${itemsPerPage}`, requestBody);
        setFilteredCampaigns(response.content);
        setTotalPages(response.totalPages);
        setTotalElements(response.totalElements);
      } catch (error: any) {
        console.error("Error fetching campaigns:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [campaignId, clientId, currentPage, itemsPerPage, location.state?.filterData]);
  const fetchAllDataForExport = async () => {
    let requestBody = [{ field: "campaignId", operator: "=", value: campaignId }, { field: "clientId", operator: "=", value: clientId }, { field: "isAvailable", operator: "=", value: false }];
    if (location.state?.filterData) {
      requestBody = [...requestBody, ...location.state.filterData];
    }
    try {
      const response = await apiCall("post", `/api/campaign-projects/search?page=0&size=${totalElements}`, requestBody);
      if (!response.content) return [];
      const transformedData = response.content.map((item: ICampaign) => {
        const exportItem: any = { ...item };
        exportItem.projectStartDate = formatDate(item.projectStartDate);
        exportItem.projectEndDate = formatDate(item.projectEndDate);
        exportItem.createdDate = formatDate(item.createdDate);
        exportItem.itemStatus = getStatusDescription(item.itemStatus);
        exportItem.auditStatus = getAuditStatusDescription(item.auditStatus);
        return exportItem;
      });
      return transformedData;
    } catch (error) {
      console.error("Error fetching all campaigns for export:", error);
      return [];
    }
  };
  useEffect(() => {
    const fetchStatusEnums = async () => {
      try {
        const response = await apiCall("get", "/api/enums/ItemStatusEnum");
        setStatusEnums(response);
      } catch (error) {
        console.error("Error fetching status enums:", error);
      }
    };
    fetchStatusEnums();
  }, []);
  useEffect(() => {
    const fetchAuditStatusEnums = async () => {
      try {
        const response = await apiCall("get", "/api/enums/AuditStatusEnum");
        setAuditStatusEnums(response);
      } catch (error) {
        console.error("Error fetching status enums:", error);
      }
    };
    fetchAuditStatusEnums();
  }, []);
  const getStatusDescription = (statusValue: string) => {
    const foundStatus = statusEnums.find(enumItem => enumItem.value === statusValue);
    return foundStatus ? foundStatus.description : statusValue;
  };
  const getAuditStatusDescription = (statusValue: string) => {
    const foundStatus = auditStatusEnums.find(enumItem => enumItem.value === statusValue);
    return foundStatus ? foundStatus.description : statusValue;
  };
  useEffect(() => {
    setSelectAll(filteredCampaigns.length > 0 && filteredCampaigns.every((campaign) => selectedProjects.has(campaign.projectId)));
  }, [filteredCampaigns, selectedProjects]);
  const formatDate = (dateString: string | undefined | null): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleCheckboxChange = (projectId: string, projectEmail: string) => {
    const updatedSelection = new Set(selectedProjects);
    const updatedEmails = [...selectedEmails];
    if (updatedSelection.has(projectId)) {
      updatedSelection.delete(projectId);
      const emailIndex = updatedEmails.indexOf(projectEmail);
      if (emailIndex > -1) updatedEmails.splice(emailIndex, 1);
    } else {
      updatedSelection.add(projectId);
      updatedEmails.push(projectEmail);
    }
    setSelectedProjects(updatedSelection);
    setSelectedEmails(updatedEmails);
  };
  const handleSelectAllChange = () => {
    if (selectedProjects.size === filteredCampaigns.length) {
      setSelectedProjects(new Set());
      setSelectedEmails([]);
    } else {
      const allProjectIds = filteredCampaigns.map((campaign) => campaign.projectId);
      const allEmails = filteredCampaigns
        .map((campaign) => campaign.projectManagerEmail)
        .filter(Boolean);
      setSelectedProjects(new Set(allProjectIds));
      setSelectedEmails(allEmails);
    }
  };
  const handleExcludeProjects = async () => {
    if (!campaignId || selectedProjects.size === 0) return;
    const adminReviewProjects = filteredCampaigns
      .filter(campaign => selectedProjects.has(campaign.projectId) &&
        campaign.itemStatus === "ADMIN_REVIEW")
      .map(campaign => campaign.projectId);
    if (adminReviewProjects.length > 0) {
      setMessage(createToastMessage(`Cannot exclude projects under admin review: ${adminReviewProjects.join(", ")}`, "error", 3000));
      return;
    }
    const assignedProjects = filteredCampaigns
      .filter(campaign =>
        selectedProjects.has(campaign.projectId) &&
        (campaign.itemStatus === "INCLUDED" || campaign.itemStatus === "FINAL_INCLUDED") &&
        (campaign.primaryAuditorName || campaign.secondaryAuditorName || campaign.assignedCheckList)
      )
    if (assignedProjects.length > 0) {
      const messageLines = assignedProjects
        .map(project => `Project are already included ${project.projectId}`)
        .join("\n");
      setMessage(createToastMessage((messageLines), "warning", 3000));
      return;
    }
    setActionType('EXCLUDE');
    setShowCommentPopup(true);
  };
  const handleIncludeProjects = async () => {
    if (!campaignId || selectedProjects.size === 0) return;
    const adminReviewProjects = filteredCampaigns
      .filter(campaign => selectedProjects.has(campaign.projectId) &&
        campaign.itemStatus === "ADMIN_REVIEW")
      .map(campaign => campaign.projectId);
    if (adminReviewProjects.length > 0) {
      setMessage(createToastMessage(`Cannot include projects under admin review: ${adminReviewProjects.join(", ")}`, "warning", 3000));
      return;
    }
    const assignedProjects = filteredCampaigns
      .filter(campaign =>
        selectedProjects.has(campaign.projectId) &&
        (campaign.itemStatus === "INCLUDED" || campaign.itemStatus === "FINAL_INCLUDED") && (campaign.primaryAuditorName || campaign.secondaryAuditorName || campaign.assignedCheckList)
      )
    if (assignedProjects.length > 0) {
      const messageLines = assignedProjects
        .map(project => `Project are already included ${project.projectId}`)
        .join("\n");
      setMessage(createToastMessage((messageLines), "warning", 3000));
      return;
    }
    setActionType('INCLUDE');
    setShowCommentPopup(true);
  };
  const handleOverrideClick = () => {
    if (selectedProjects.size === 0) {
      setMessage(createToastMessage("Please select at least one project to override", "warning", 3000));
      return;
    }
    const alreadyIncludedProjects = filteredCampaigns
      .filter(campaign => selectedProjects.has(campaign.projectId) &&
        (campaign.itemStatus === "INCLUDED" || campaign.itemStatus === "FINAL_INCLUDED"))
      .map(campaign => campaign.projectId);
    if (alreadyIncludedProjects.length > 0) {
      setMessage(createToastMessage(`Projects already included: ${alreadyIncludedProjects.join(", ")}`, "warning", 3000));
      return;
    }
    const adminReviewProjects = filteredCampaigns
      .filter(campaign => selectedProjects.has(campaign.projectId) && campaign.itemStatus === "ADMIN_REVIEW")
      .map(campaign => campaign.projectId);
    if (adminReviewProjects.length > 0) {
      setMessage(createToastMessage(`Projects under admin review (cannot be overridden): ${adminReviewProjects.join(", ")}`, "error", 3000));
      return;
    }
    setActionType('OVERRIDE');
    setShowOverridePopup(true);
  };
  const calculateEstimatedTime = (processed: number, total: number): string => {
    if (processed === 0 || startTimeRef.current === 0) return "Calculating...";
    const elapsedSeconds = (Date.now() - startTimeRef.current) / 1000;
    const rate = processed / elapsedSeconds;
    const remaining = total - processed;
    const estimatedSeconds = remaining / rate;
    if (estimatedSeconds < 60) {
      return `${Math.ceil(estimatedSeconds)} seconds`;
    } else if (estimatedSeconds < 3600) {
      return `${Math.ceil(estimatedSeconds / 60)} minutes`;
    } else {
      return `${(estimatedSeconds / 3600).toFixed(1)} hours`;
    }
  };
  const confirmAction = async () => {
    if (actionType === 'OVERRIDE') {
      setShowOverridePopup(false);
    } else {
      setShowCommentPopup(false);
    }
    if (!remark.trim()) {
      setMessage(createToastMessage("Please provide a comment for this action", "warning", 3000));
      return;
    }
    try {
      if (actionType === 'OVERRIDE') {
        cleanupPolling();
        startTimeRef.current = Date.now();
        processedCountRef.current = 0;
        setOverrideProgress({ total: selectedProjects.size, processed: 0, status: "Starting override process...", successCount: 0, failedCount: 0, failedProjects: [], estimatedTimeRemaining: "Calculating..." });
        setIsProcessingOverride(true);
        await processDirectOverrideWithChunks();
      } else {
        const status = actionType === 'EXCLUDE' ? 'EXCLUDED' : 'INCLUDED';
        await apiCall("patch", `/api/campaign-projects/status/${campaignId}`, { itemStatus: "ADMIN_REVIEW", status: status, projectIds: Array.from(selectedProjects), remark: remark.trim() });
        setMessage(createToastMessage(`Projects ${actionType === 'EXCLUDE' ? 'excluded' : 'included'} successfully!`, "success", 2500));
        setRemark("");
        setSelectedProjects(new Set());
        setSelectedEmails([]);
        setTimeout(() => window.location.reload(), 3000);
      }
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || error.message || "An unexpected error occurred";
      setMessage(createToastMessage(errorMessage, "error", 3000));
      setIsProcessingOverride(false);
      setOverrideProgress(null);
    } finally {
      if (actionType !== 'OVERRIDE') {
        setActionType(null);
      }
    }
  };
  const processDirectOverrideWithChunks = async () => {
    try {
      const projectIds = Array.from(selectedProjects);
      const chunkSize = selectedProjects.size > 100 ? 10 : 20;
      let successCount = 0;
      let failedCount = 0;
      const failedProjects: string[] = [];
      abortControllerRef.current = new AbortController();
      for (let i = 0; i < projectIds.length; i += chunkSize) {
        if (abortControllerRef.current?.signal.aborted) {
          break;
        }
        const chunk = projectIds.slice(i, Math.min(i + chunkSize, projectIds.length));
        setOverrideProgress(prev => prev ? { ...prev, processed: i, status: `Processing chunk ${Math.floor(i / chunkSize) + 1}/${Math.ceil(projectIds.length / chunkSize)}...`, estimatedTimeRemaining: calculateEstimatedTime(i, projectIds.length) } : null);
        try {
          await apiCall("post", "/api/campaign-projects/override", { campaignId, projectIds: chunk, remark: remark.trim() }, { signal: abortControllerRef.current?.signal });
          successCount += chunk.length;
          processedCountRef.current = i + chunk.length;
        } catch (error: any) {
          if (error.name === 'AbortError' || abortControllerRef.current?.signal.aborted) {
            console.error("Override process cancelled by user");
            break;
          }
          failedCount += chunk.length;
          failedProjects.push(...chunk);
          console.error(`Failed to process chunk:`, error);
        }
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      setOverrideProgress(prev => prev ? { ...prev, processed: projectIds.length, successCount, failedCount, failedProjects, status: failedCount > 0 ? "Processing completed with some failures" : "Processing completed!", estimatedTimeRemaining: "Completed" } : null);
      let finalMessage = `Override completed! ${successCount} project(s) succeeded`;
      if (failedCount > 0) {
        finalMessage += `, ${failedCount} failed`;
        if (failedProjects.length > 0 && failedProjects.length <= 10) {
          finalMessage += `: ${failedProjects.join(", ")}`;
        } else if (failedProjects.length > 10) {
          finalMessage += ` (first 10: ${failedProjects.slice(0, 10).join(", ")})`;
        }
      }
      const messageType = failedCount > 0 ? "warning" : "success";
      const messageDuration = failedCount > 0 ? 8000 : 5000;
      setMessage(createToastMessage(finalMessage, messageType, messageDuration));
      setTimeout(() => {
        setIsProcessingOverride(false);
        setOverrideProgress(null);
        setRemark("");
        setSelectedProjects(new Set());
        setSelectedEmails([]);
        setActionType(null);
        cleanupPolling();
        if (!abortControllerRef.current?.signal.aborted) {
          window.location.reload();
        }
      }, 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || error.message || "An unexpected error occurred";
      setMessage(createToastMessage(errorMessage, "error", 3000));
      setIsProcessingOverride(false);
      setOverrideProgress(null);
      cleanupPolling();
    }
  };
  useEffect(() => {
    const fetchAdminReviewCount = async () => {
      try {
        const payload = buildUserPayload();
        const requestBody = [{ field: "campaignId", operator: "=", value: campaignId }, { field: "itemStatus", operator: "=", value: "ADMIN_REVIEW" }, ...(payload ? [payload] : [])];
        const response = await apiCall("post", `/api/campaign-projects/search?page=0&size=2147483647`, requestBody);
        setAdminReviewCount(response?.totalElements || 0);
      } catch (error) {
        console.error("Error fetching admin review count:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAdminReviewCount();
  }, [campaignId, currentPage, itemsPerPage]);
  const handleAuditorAssign = async () => {
    try {
      setLoading(true);
      if (!campaignId || selectedProjects.size === 0) {
        setMessage(createToastMessage("Please select at least one project.", "warning", 3000));
        return;
      }
      const notReviewedProjects = filteredCampaigns
        .filter(campaign => selectedProjects.has(campaign.projectId) && ["PENDING", "QC_REVIEW", "ADMIN_REVIEW"].includes(campaign.itemStatus))
        .map(campaign => campaign.projectId);
      if (notReviewedProjects.length > 0) {
        setMessage(createToastMessage(`Please review the following project(s) before assigning auditor: ${notReviewedProjects.join(", ")}`, "warning", 3000));
        return;
      }
      const missingChecklistProjects = filteredCampaigns
        .filter(campaign =>
          selectedProjects.has(campaign.projectId) &&
          (!campaign.assignedCheckList || campaign.assignedCheckList.trim() === "")
        )
        .map(campaign => campaign.projectId);
      if (missingChecklistProjects.length > 0) {
        setMessage(createToastMessage(`Cannot assign auditor. The following project(s) do not have an assigned checklist: ${missingChecklistProjects.join(", ")}`, "warning", 3000));
        return;
      }
      const roles: any[] = await apiCall("get", `/api/roles/all/${clientId}`);
      const auditorRole = roles.find(role => role.name === "Auditor");
      if (!auditorRole) {
        setMessage(createToastMessage("Auditor role not found.", "error", 3000));
        return;
      }
      const payload = { campaignId, projectIds: Array.from(selectedProjects), roleId: auditorRole.id, clientId: clientId || "", updatedBy: updatedBy || "", providerId, loggedInEmail };
      const response = await apiCall("post", `/api/auditor-assignment/assignAuditor`, payload);
      let displayMessage = "Auditor Assigned Successfully";
      let responseText = "";
      if (response && typeof response === 'object') {
        if (response.data) {
          responseText = String(response.data);
        }
        else if (response.message) {
          responseText = String(response.message);
        }
        else {
          responseText = JSON.stringify(response);
        }
      } else if (typeof response === 'string') {
        responseText = response;
      }
      if (responseText.includes("Auditor Assigned By AI")) {
        displayMessage = "Auditor Assigned Successfully - Auditor Assigned By AI";
      }
      else if (responseText.includes("Auditor Assigned By System FallBack Method")) {
        displayMessage = "Auditor Assigned Successfully - Auditor Assigned By System FallBack Method";
      }
      else if (responseText.includes("Assigned auditors successfully")) {
        displayMessage = "Auditor Assigned Successfully";
      }
      setMessage(createToastMessage((displayMessage), "success", 3000));
      setTimeout(() => { window.location.reload() }, 3000);
    } catch (error: any) {
      let errorMessage = "Error assigning Auditors";
      if (error?.response?.data) {
        if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      } else if (error?.message) {
        errorMessage = error.message;
      }
      setMessage(createToastMessage(errorMessage, "error", 3000));
    } finally {
      setLoading(false);
    }
  };
  const renderSortIcon = (key: string) => {
    if (!sortConfig || sortConfig.key !== key) {
      return <FaSort />;
    }
    return sortConfig.direction === 'ascending' ? <FaSortUp /> : <FaSortDown />;
  };
  const canShowOverrideButton = () => {
    if (!qcBufferDate) return false;
    const bufferDate = new Date(qcBufferDate);
    bufferDate.setHours(0, 0, 0, 0);
    const bufferEndDate = new Date(bufferDate);
    bufferEndDate.setDate(bufferEndDate.getDate() + 1);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today <= bufferEndDate;
  };
  const handleProjectClick = (campaign: ICampaign) => {
    EncryptionUtils.set("campaignName", campaignName || "");
    navigate(`/campaignDetailsInfo/${campaign.projectId}/${campaignId}`, { state: { campaignStatus } });
  };
  const renderProjectId = (campaign: ICampaign) => {
    return (
      <div className="project-id-cell">
        {campaign.isReusedFromPrevious && (
          <HiArrowPath className="reuse-icon" title={`Reused from campaign: ${campaign.reusedFromCampaignId}`} />
        )}
        <span className={`clickable ${campaign.isReusedFromPrevious ? "reused-project" : ""}`} onClick={() => handleProjectClick(campaign)}>{campaign.projectId}</span>
      </div>
    );
  };
  const renderTableHeaders = () => (
    <tr>
      <th>
        <input type="checkbox" checked={selectAll} onChange={handleSelectAllChange} />
      </th>
      {columns.map((header) => {
        const isSortable = ['projectId', 'projectName'].includes(header.key);
        return (
          <th key={header.key} onClick={isSortable ? () => requestSort(header.key) : undefined} className={isSortable ? 'sortable-header' : 'normal-header'}> {header.label} {isSortable && renderSortIcon(header.key)}</th>
        );
      })}
    </tr>
  );
  const getStatusClass = (status: string) => {
    switch (status) {
      case "QC_REVIEW":
        return "status-qc-review";
      case "ADMIN_REVIEW":
        return "status-admin-review";
      case "FINAL_INCLUDED":
        return "status-final-included";
      case "FINAL_EXCLUDED":
        return "status-final-excluded";
      case "AUTO_INCLUDED":
        return "status-auto-included";
      case "EXCLUDED":
        return "status-excluded";
      case "INCLUDED":
        return "status-included";
      default:
        return "status-text";
    }
  };
  const renderTableRows = () => {
    if (sortedCampaigns.length === 0) {
      return (
        <tr>
          <td colSpan={columns.length + 1} className="no-data">No project(s) found / No project(s) associated with this {campaignId}</td>
        </tr>
      );
    }
    return sortedCampaigns.map((campaign) => (
      <tr key={`${campaign.campaignId}-${campaign.projectId}`} className={campaign.isReusedFromPrevious ? 'reused-row' : ''}>
        <td>
          <input type="checkbox" checked={selectedProjects.has(campaign.projectId)} onChange={() => handleCheckboxChange(campaign.projectId, campaign.projectManagerEmail)} />
        </td>
        {fields.view && (<td>{renderProjectId(campaign)}</td>)}
        <td className={campaign.isReusedFromPrevious ? 'reused-project' : ''}>{campaign.projectName}</td>
        {columns.slice(2).map((header) => {
          const key = header.key;
          const value = campaign[key];
          if (key === "itemStatus") {
            const status = value || "";
            return (
              <td key={key}>
                <span className={`${getStatusClass(status)} ${status === "ADMIN_REVIEW" ? "blinking-text" : ""}`}>{getStatusDescription(status)}</span>
              </td>
            );
          }
          if (key === "auditStatus") {
            const status = value || "";
            return (
              <td key={key}>
                {getAuditStatusDescription(status)}
              </td>
            );
          }
          if (key === "remarkByQC" || key === "remarkByAdmin") {
            return (
              <td key={key} className={`${key}-cell`}>
                <div className="remark-content">{value || "N/A"}</div>
              </td>
            );
          }
          return (
            <td key={key}>
              {key.toLowerCase().includes("date") ? value ? formatDate(value) : "N/A" : value || "N/A"}
            </td>
          );
        })}
      </tr>
    ));
  };
  const handleNavigateToUnassigned = () => {
    navigate(`/addproject/${campaignName}`, { state: { campaignId: campaignId } });
  };
  const handleNavigateToAdminReview = () => {
    navigate(`/adminreview/${campaignName}`, { state: { campaignId: campaignId } });
  };
  const handleNavigateToFilters = () => {
    navigate(`/filters/${campaignId}`);
  };
  const handleNavigateToExcludedProjects = () => {
    navigate(`/excludedprojectdetails/${campaignId}`)
  }
  const handleNavigateToHistory = () => {
    navigate(`/campaignprojecthistory/${campaignId}`)
  }
  const columns = [{ label: "Project ID", key: "projectId" }, { label: "Project Name", key: "projectName" }, { label: "Campaign Name", key: "campaignName" }, { label: "Item Status", key: "itemStatus" }, { label: "Audit Status", key: "auditStatus" }, { label: "Remark By QC", key: "remarkByQC" }, { label: "Remark By Admin", key: "remarkByAdmin" }, { label: "Primary Auditor Name", key: "primaryAuditorName" }, { label: "Secondary Auditor Name", key: "secondaryAuditorName" }, { label: "Account ID", key: "accountId" }, { label: "Account Name", key: "accountName" }, { label: "Business Unit", key: "businessUnit" }, { label: "Estimation Model", key: "estimationModel" }, { label: "DevOps CI/CD Tool", key: "devOps_CICDtoolname" }, { label: "Testing Tool Name", key: "testingToolName" }, { label: "Code Quality Tool Name", key: "codequalityToolName" }, { label: "Customer Location", key: "customerLocation" }, { label: "Project Location", key: "projectLocation" }, { label: "Project Life Cycle", key: "projectLifeCycle" }, { label: "Team Size", key: "teamSize" }, { label: "Architect", key: "architect" }, { label: "Delivery Model", key: "deliveryModel" }, { label: "Billing Type", key: "billingType" }, { label: "Project Manager Name", key: "projectManagerName" }, { label: "Project Manager Email", key: "projectManagerEmail" }, { label: "Delivery Manager Name", key: "deliveryManagerName" }, { label: "Delivery Manager Email", key: "deliveryManagerEmail" }, { label: "Delivery Head Name", key: "deliveryHeadName" }, { label: "Delivery Head Email", key: "deliveryHeadEmail" }, { label: "Quality Consultant Name", key: "qualityConsultantName" }, { label: "Quality Consultant Email", key: "qualityConsultantEmail" }, { label: "Quality Manager Name", key: "qualityManagerName" }, { label: "Quality Manager Email", key: "qualityManagerEmail" }, { label: "Test Manager Email", key: "testManagerEmail" }, { label: "Technical Lead Name", key: "technicalLeadName" }, { label: "Technical Lead Email", key: "technicalLeadEmail" }, { label: "Project Start Date", key: "projectStartDate" }, { label: "Project End Date", key: "projectEndDate" }, { label: "Created By", key: "createdBy" }, { label: "Created Date", key: "createdDate" }];
  const handleRemarkChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (restrictedChars.test(value)) {
      setMessage(createToastMessage(`Special characters are not allowed - ${restrictedChars}`, "warning", 3000));
      return;
    }
    setRemark(value);
  };
  const isHistoryAvailable = localStorage.getItem("isHistoryAvailable") === "true";
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Campaign Projects - {campaignName}</h2>
        <div className="table-title-actions">
          {campaignStatus === "NOT_STARTED" &&  canShowProjectActionButtons() && selectedProjects.size > 0 && roleName === "Quality Consultant" && (
              <>
                <button className="addbtn" onClick={handleIncludeProjects}>Include projects</button>
                <button className="addbtn" onClick={handleExcludeProjects}>Exclude projects</button>
              </>
            )}
          {campaignStatus === "STARTED" && fields.create && ["Admin", "Primary Spoc", "Secondary Spoc", "Super Admin"].includes(roleName) && (
            <button className="addbtn" onClick={handleAuditorAssign}>Auditor Assign</button>
          )}
          {campaignStatus === "NOT_STARTED" && fields.create && ["Admin", "Primary Spoc", "Secondary Spoc", "Super Admin"].includes(roleName) && (
            <button className="notification-btn" onClick={handleNavigateToAdminReview}>Action Required{adminReviewCount > 0 && (<span className="notification-badge">{adminReviewCount}</span>)}</button>
          )}
          {campaignStatus === "NOT_STARTED" && fields.view &&
            (["Admin", "Primary Spoc", "Secondary Spoc", "Super Admin"].includes(roleName) || (roleName === "Quality Consultant" && canShowProjectActionButtons())) && (
              <button className="addbtn" onClick={handleNavigateToUnassigned}>Unassigned Projects</button>
            )}
          {campaignStatus === "STARTED" && ["Admin", "Primary Spoc", "Secondary Spoc", "Super Admin"].includes(roleName) && canShowOverrideButton() && (
            <button className="addbtn" onClick={handleOverrideClick} disabled={isProcessingOverride}>{isProcessingOverride ? "Processing..." : "Override"} </button>
          )}
          {isHistoryAvailable && fields.create && ["Admin", "Primary Spoc", "Secondary Spoc", "Super Admin", "Quality Consultant"].includes(roleName) && (<button className="addbtn" onClick={handleNavigateToHistory}>Campaign Project History</button>)}
          {campaignStatus === "NOT_STARTED" && "STARTED" && fields.view && (
            <button className="addbtn" onClick={handleNavigateToExcludedProjects}>Excluded Projects</button>
          )}
          <button className="addbtn" onClick={handleNavigateToFilters}>Filters</button>
          <ExportButton data={sortedCampaigns} columns={columns} fetchAllData={fetchAllDataForExport} fileName={`campaign${campaignId} projects`} />
        </div>
      </div>
      <>
        <div className="table-container">
          <div className="table-inner-container">
            <table className="main-table">
              <thead>{renderTableHeaders()}</thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
          </div>
        </div>
        <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      </>
      {isProcessingOverride && overrideProgress && (
        <div className="review-overlay">
          <div className="review-content progress-modal">
            <h3>Processing Override</h3>
            <div className="progress-container">
              <div className="progress-text">
                <p className="progress-status">{overrideProgress.status}</p>
                <p className="progress-counts">Processed: {overrideProgress.processed} / {overrideProgress.total} projects
                  {overrideProgress.successCount > 0 && ` • Succeeded: ${overrideProgress.successCount}`}
                  {overrideProgress.failedCount > 0 && ` • Failed: ${overrideProgress.failedCount}`}
                </p>
                <p className="progress-estimate">Estimated time remaining: {overrideProgress.estimatedTimeRemaining}</p>
              </div>
              {overrideProgress.total > 0 && (
                <div className="progress-bar">
                  <div className="progress-fill" style={{ width: `${Math.min(100, (overrideProgress.processed / overrideProgress.total) * 100)}%` }} />
                </div>
              )}
              {overrideProgress.failedProjects.length > 0 && overrideProgress.failedProjects.length <= 5 && (
                <div className="failed-projects">
                  <p className="failed-title">Failed projects:</p>
                  <ul className="failed-list">
                    {overrideProgress.failedProjects.map((projectId, index) => (
                      <li key={index}>{projectId}</li>
                    ))}
                  </ul>
                </div>
              )}
              <p className="processing-note">Processing {overrideProgress.total} projects in chunks to avoid timeout.
              </p>
              <div className="progress-buttons">
                <button className="cancelbutton" onClick={() => {
                  if (abortControllerRef.current) {
                    abortControllerRef.current.abort();
                  }
                  cleanupPolling();
                  setIsProcessingOverride(false);
                  setOverrideProgress(null);
                  setActionType(null);
                  setMessage(createToastMessage("Override process cancelled. Some projects may have been processed.", "warning", 4000));
                }}>Cancel Process
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showCommentPopup && (
        <div className="review-overlay">
          <div className="review-content">
            <h3>{actionType === 'EXCLUDE' ? 'Exclude' : 'Include'} Projects</h3>
            <p>Please provide comments for {actionType === 'EXCLUDE' ? 'excluding' : 'including'} these projects:</p>
            <textarea value={remark} onChange={handleRemarkChange} placeholder="Enter your comments here..." rows={4} />
            <div className="buttons">
              <button className="cancelbutton" onClick={() => setShowCommentPopup(false)}>Cancel</button>
              <button className="savebutton" onClick={confirmAction}>Confirm</button>
            </div>
          </div>
        </div>
      )}
      {showOverridePopup && !isProcessingOverride && (
        <div className="review-overlay">
          <div className="review-content">
            <h3>Override Projects</h3>
            <p>Please provide comments for overriding {selectedProjects.size} project(s):</p>
            <p className="override-note">{selectedProjects.size > 50 ? `Processing ${selectedProjects.size} projects in small chunks to prevent timeout errors.   This ensures all projects are processed successfully.` : `Processing ${selectedProjects.size} projects with progress tracking.`}</p>
            <textarea value={remark} onChange={handleRemarkChange} placeholder="Enter your comments here..." rows={4} />
            <div className="buttons">
              <button className="cancelbutton" onClick={() => setShowOverridePopup(false)}>Cancel</button>
              <button className="savebutton" onClick={confirmAction}>Start Override</button>
            </div>
          </div>
        </div>
      )}
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default CampaignDetailsProjects;